import React from 'react'

import './footer.css';

function Footer() {
  return (
    <section className="bottom-0 start-0 end-0" style={{display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', backgroundColor: '#fdf5df'}}>
      
      <div style={{marginTop: '15px', marginBottom: '10px'}}>
              <a href="/" style={{color:'black', }} >
                <button className='footer-button'>
                  Back to Top
                </button>
              </a>
      </div>
      <p className="meauto" style={{textAlign: 'center'}}>© 2022 by Ian Gray</p>
    </section>
  )
}

export default Footer